export class FreeForm {
    public searchWith:any;
	public  feedType: string;
	public  feedID: number;
	public  searchString: string;
	public  salesRepId: any;
    public  searchDate: any;
    constructor()
    {
        this.searchWith = null;
        this.feedType = null;
        this.feedID = null;
        this.searchString = null;
        this.salesRepId = null;
        this.searchDate = null;

    }
}
